var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showSheet)?_c('div',{class:[
    _vm.sheetClass,
  ],attrs:{"id":"sac-bottom-sheet-overlay"}},[(_vm.close)?_c('div',{staticClass:"close-background",on:{"click":_vm.hideSheet}}):_vm._e(),_c('div',{class:[
      'sheet-card',
      _vm.show ? 'slide-up' : 'slide-down',
      _vm.cardClass,
    ]},[_vm._t("content")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }